import WizardSection from 'ui/components/wizard/WizardSection';
import Info from 'ui/sections/file/record/pages/Info';
import { Urls } from 'urls';

export default class SectionRecord extends WizardSection {
  static url = '/record/';
  static title = 'Record';
  static description = 'Record your notarized Home Transfer Deed.';
  static finalUrl = Urls.file;
  static fallbackUrl = Urls.file;
  static showFooter = false;

  static getPageFlow(clientData, serverData, experimentContext, visit) {
    visit(Info);
  }
}
